import { MainLayout as AdminMainLayout } from './layout/MainLayout';
import { MobileLayout as AdminMobileLayout } from './layout/MobileLayout';
import { SettingLayout as AdminSettingLayout } from './layout/SettingLayout';
import { AuthLayout as AdminAuthLayout } from './layout/AuthLayout';
import { PrintLayout as AdminPrintLayout } from './layout/PrintLayout';
import { ErrorLayout as AdminErrorLayout } from './layout/ErrorLayout';

export const AdminCommonTheme = {
    MainLayout: AdminMainLayout,
    MobileLayout: AdminMobileLayout,
    SettingLayout: AdminSettingLayout,
    AuthLayout: AdminAuthLayout,
    PrintLayout: AdminPrintLayout,
    ErrorLayout: AdminErrorLayout
}